// src/i18n.ts
import i18n, { CallbackError, ReadCallback } from "i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { PublicAssetFrontendI18nApi } from "@/custolink-transpiled_by_server/bc.identity_and_access.api_methods";

export const i18nQueryStringParamName = "i18nlng"

export async function initI18n(
  uiAppScope: "asset_frontend",
  i18nLanguageCodes: string[],
) {

  const i = i18n.createInstance();
  i.use(HttpBackend).use(LanguageDetector).use(initReactI18next);

  await i.init({
    fallbackLng: i18nLanguageCodes[0], // it would be a mega error if no entries were found
    supportedLngs: i18nLanguageCodes, // keep aligned with server-supported locales
    defaultNS: "*",
    ns: ["*"],
    backend: {
      // Spring Boot endpoint returning JSON bundle per language + namespace
      loadPath: `${uiAppScope}/{{lng}}/{{ns}}`,
      request: async function (
        _options: unknown,
        url: string,
        _payload: unknown,
        callback: ReadCallback,
      ) {
        const params = url.split("/"); // a bit of a hack: i18n will transform loadPath into url, where the placeholders will be replaced
        let res = {};
        try {
          res = await PublicAssetFrontendI18nApi.loadNamespace(
            params[0],
            params[1],
            params[2],
          );
        } catch (err) {
          callback(err as CallbackError, null);
          return;
        }
        callback(null, {
          status: 200,
          data: res,
        });
      },
    },

    detection: {
      order: ["querystring","localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nlng",
      lookupQuerystring: "i18nlng"
    },

    interpolation: {
      escapeValue: false, // React already escapes
    },

    react: {
      useSuspense: true,
    },

    // Recommended to reduce noisy logs in production
    debug: import.meta.env.DEV,
  });

  return i;
}
